import React, { useEffect, useRef } from 'react';
import { GOOGLE_ADS_CLIENT } from '../../lib/config';

const GoogleFixedAds = ({
  className = '',
  style = {},
  client = GOOGLE_ADS_CLIENT,
  slot = '7994459917',
  format = 'auto',
  fullWidthResponsive = false,
  adStyle = 'display:block'
}) => {
  const adRef = useRef(null);
  const isInitialized = useRef(false);

  useEffect(() => {
    const initializeAd = () => {
      if (adRef.current && !isInitialized.current && window.adsbygoogle) {
        try {
          // Check if this specific ad hasn't been initialized yet
          if (!adRef.current.hasAttribute('data-adsbygoogle-status')) {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
            isInitialized.current = true;
          }
        } catch (err) {
          // Only log errors in production, not on localhost
          if (!window.location.hostname.includes('localhost')) {
            console.error('Error loading Google Ads:', err);
          }
        }
      }
    };

    // Only initialize ads if not on localhost
    if (!window.location.hostname.includes('localhost')) {
      if (window.adsbygoogle) {
        initializeAd();
      } else {
        const timer = setTimeout(initializeAd, 100);
        return () => clearTimeout(timer);
      }
    }
  }, []);

  // Show placeholder in development
  const isLocalhost = window.location.hostname.includes('localhost');

  return (
    <div className={className} style={style}>
      {isLocalhost ? (
        <div 
          style={{ 
            ...style, 
            display: 'block', 
            background: '#f0f0f0', 
            border: '1px dashed #ccc',
            textAlign: 'center',
            padding: '20px',
            color: '#666'
          }}
        >
          Ad Placeholder (Localhost)
        </div>
      ) : (
        <ins
          ref={adRef}
          className="adsbygoogle"
          style={{ ...style, ...{ display: 'block' } }}
          data-ad-client={client}
          data-ad-slot={slot}
          data-ad-format={format}
          data-full-width-responsive={fullWidthResponsive}
        />
      )}
    </div>
  );
};

export default GoogleFixedAds;
